import React from 'react';
import { Transition } from 'react-transition-group';

type FadeProps = {
  in?: boolean;
  timeout: number;
  className?: string;
  element?: keyof React.ReactHTML;
};

const Fade: React.FC<FadeProps> = (props) => {
  const Component: typeof props.element = props.element || 'div';
  return (
    <Transition in={props.in} timeout={{ enter: 0, exit: props.timeout }}>
      {(state) => (
        <Component
          className={props.className}
          style={{
            transition: `opacity ${props.timeout}ms`,
            opacity: state === 'entered' ? 1 : 0,
            ...(state === 'exited' ? { display: 'none' } : {}),
          }}
        >
          {props.children}
        </Component>
      )}
    </Transition>
  );
};

export default Fade;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/transitions/Fade.tsx